import { compact, concat } from 'lodash';
import { gearMenuItem, blogMenuItem, privacyEmployeeMenuItem, privacyMenuItem, getFeedbackMenuItem, } from './premadeItem';
import { useThemeCommandBarItem, } from '../../theme/useThemeCommandBarItem';
import { usePreviewToggle } from './usePreviewToggle';
/** Hook to generate the "gear" menu that rolls up a bunch of settings controls and info links */
export const useAppBarFarGearMenuItem = ({ items = [], isInternalPortal, supportFormUrl, stringsGearMenu: { stringsFeedbackItem, stringsPreviewItem, stringsPrivacyItem, stringsThemeItem, } = {}, }) => {
    const themeMenuItem = useThemeCommandBarItem({ stringsThemeItem });
    const previewToggle = usePreviewToggle({ stringsPreviewItem });
    return Object.assign(Object.assign({}, gearMenuItem), { subMenuProps: {
            items: compact(concat(items, [
                getFeedbackMenuItem({ href: supportFormUrl, stringsFeedbackItem }),
                themeMenuItem,
                previewToggle,
                blogMenuItem,
                isInternalPortal
                    ? privacyEmployeeMenuItem
                    : privacyMenuItem(stringsPrivacyItem),
            ])),
        } });
};
